export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5163.6269470b.jpg";